import { KeyValueModel, KeyValueRoleElevatedModel } from '@models/common';
import { ContractRole } from '@models/module/main';
import { Tenant } from '@models/module/tenant';
import { CipoSignature } from '@module-definition/signature/common';
import { ContextInfo } from '@system/context';

export const CIPO_ADMIN_ROLE_ID = -2;

/** SYS Admin Root — full system administrator access; can do anything. */
export const SYS_ROLE_ROOT_ID = -1;

/** SYS Admin Support — developer / QA / support access. */
export const SYS_ROLE_SUPPORT_ID = -2;

/** SYS Admin Financial — financial admin access (e.g. AI cost reports). */
export const SYS_ROLE_FINANCIAL_ID = -3;

/** SYS Admin High Risk Operations — e.g. deleting users. */
export const SYS_ROLE_HIGH_RISK_ID = -4;

/** All sys-admin-tier role IDs. Root implicitly satisfies checks scoped to this set only. */
export const SYS_ADMIN_ROLE_IDS = [
  SYS_ROLE_ROOT_ID,
  SYS_ROLE_SUPPORT_ID,
  SYS_ROLE_FINANCIAL_ID,
  SYS_ROLE_HIGH_RISK_ID,
] as const;

export interface User {
  id: number;
  sysUserId: number;
  firstName: string;
  lastName: string;
  displayName: string;
  email: string;
  lang1: string;
  lang2: string;
  tenantId: number;
  tenantIdentifier: string;
  logo?: string;
  //   contractId?: number; not available
  isSuper?: boolean;
  disabledOnTenant: boolean;
  phoneNumber: string;
  phoneNumberCountryCode: string;
  organizationName: string;
  appVersion: string;
  isUserExternal: boolean;
  hasCorrespondenceAccess: boolean;
  loadMore: boolean;
  context: ContextInfo;
  defaultCurrencyId: number;
  tenants: Tenant[];
  windowsTimeZoneId: string;
  ianaTimeZoneId: string;
  isLoading?: boolean;
  signature?: CipoSignature;
  roles: KeyValueRoleElevatedModel<number, string>[];
  /** Sys roles assigned in the system database (SysUserRole). */
  sysRoles: KeyValueModel<number, string>[];
  dashboardLastVisitedModuleId?: number;
  lastVisitedModuleId?: number;
  managerId?: number;
  managerName?: string;
  showLastVisitedModule: boolean;
  rolesOnCurrentContract: ContractRole[];
}

export interface UserSettings {
  dateFormat: string;
  timeFormat: string;
  datetimeFormat: string;
  decimalSeparator: string;
  thousandSeparator: string;
  loadMore: boolean;
  showLastVisitedModule: boolean;
}
